import * as React from "react";
const ReconnectBankIcon = (props: any) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.4201 12.2203C20.0101 12.2203 19.6701 11.8803 19.6701 11.4703V8.15039C19.6701 6.91039 18.6601 5.90039 17.4201 5.90039H3.58008C3.17008 5.90039 2.83008 5.56039 2.83008 5.15039C2.83008 4.74039 3.17008 4.40039 3.58008 4.40039H17.4201C19.4901 4.40039 21.1701 6.08039 21.1701 8.15039V11.4703C21.1701 11.8903 20.8301 12.2203 20.4201 12.2203Z"
      fill="#19224C"
    />
    <path
      d="M6.74008 9.06949C6.55008 9.06949 6.36008 8.99946 6.21008 8.84946L3.05008 5.68949C2.91008 5.54949 2.83008 5.35946 2.83008 5.15946C2.83008 4.95946 2.91008 4.76949 3.05008 4.62949L6.21008 1.46945C6.50008 1.17945 6.98008 1.17945 7.27008 1.46945C7.56008 1.75945 7.56008 2.23951 7.27008 2.52951L4.64011 5.15946L7.27008 7.78946C7.56008 8.07946 7.56008 8.55946 7.27008 8.84946C7.12008 8.98946 6.93008 9.06949 6.74008 9.06949Z"
      fill="#19224C"
    />
    <path
      d="M20.4201 19.5895H6.58008C4.51008 19.5895 2.83008 17.9095 2.83008 15.8395V12.5195C2.83008 12.1095 3.17008 11.7695 3.58008 11.7695C3.99008 11.7695 4.33008 12.1095 4.33008 12.5195V15.8395C4.33008 17.0795 5.34008 18.0895 6.58008 18.0895H20.4201C20.8301 18.0895 21.1701 18.4295 21.1701 18.8395C21.1701 19.2495 20.8301 19.5895 20.4201 19.5895Z"
      fill="#19224C"
    />
    <path
      d="M17.2592 22.7491C17.0692 22.7491 16.8792 22.6791 16.7292 22.5291C16.4392 22.2391 16.4392 21.7591 16.7292 21.4691L19.3592 18.8391L16.7292 16.2091C16.4392 15.9191 16.4392 15.4391 16.7292 15.1491C17.0192 14.8591 17.4992 14.8591 17.7892 15.1491L20.9492 18.3091C21.0892 18.4491 21.1692 18.6391 21.1692 18.8391C21.1692 19.0391 21.0892 19.2291 20.9492 19.3691L17.7892 22.5291C17.6492 22.6791 17.4592 22.7491 17.2592 22.7491Z"
      fill="#19224C"
    />
  </svg>
);
export default ReconnectBankIcon;
